import { useEffect } from "react";
import { isWebView } from "src/utilities/isWebView";
import { hideSiteChrome } from "src/utilities/hideSiteChrome";
import { setBannerCookie } from "src/utilities/setBannerCookie";

const useNativeHandover = () => {
  const webView = isWebView();

  useEffect(() => {
    if (webView) {
      setBannerCookie();
      hideSiteChrome();
    }
  }, [webView]);
};

export default useNativeHandover;
